import apiService from './api';
import { HomepageBanner, Designer } from '../types';

export interface HomepageDressEntry {
  id: string;
  displayOrder: number;
  dress: {
    id: string;
    name: string;
    description?: string;
    imageUrl?: string;
    thumbnailUrl?: string;
    designer?: {
      id: string;
      name: string;
    };
  };
}

export interface HomepageService {
  getBanners(): Promise<HomepageBanner[]>;
  getFeaturedDesigners(): Promise<Designer[]>;
  getHomepageDresses(section: 'style_matcher' | 'collection'): Promise<HomepageDressEntry[]>;
}

class HomepageServiceImpl implements HomepageService {
  async getBanners(): Promise<HomepageBanner[]> {
    try {
      const response = await apiService.get<HomepageBanner[]>('/homepage-banners');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch homepage banners:', error);
      throw error;
    }
  }

  async getFeaturedDesigners(): Promise<Designer[]> {
    try {
      const response = await apiService.get<Designer[]>('/featured-designers');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch featured designers:', error);
      throw error;
    }
  }

  async getHomepageDresses(section: 'style_matcher' | 'collection'): Promise<HomepageDressEntry[]> {
    try {
      const response = await apiService.get<HomepageDressEntry[]>(`/homepage-dresses/${section}`);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch homepage dresses for ${section}:`, error);
      throw error;
    }
  }
}

const homepageService = new HomepageServiceImpl();
export default homepageService;